'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = NotFound;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NotFound() {
  return _react2.default.createElement(
    'div',
    { className: 'container' },
    _react2.default.createElement(
      'h2',
      { style: { textAlign: 'center', marginTop: 50, marginBottom: 50 } },
      'Trang c\u1EE7a b\u1EA1n kh\xF4ng t\xECm th\u1EA5y'
    ),
    _react2.default.createElement(_components.ProminentShopHorizontalList, { boxNumber: 4 }),
    _react2.default.createElement(_components.SuggestedShopHorizontalList, { boxNumber: 4 })
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/NotFound/NotFound.js
// module id = 1681
// module chunks = 0